import { render, staticRenderFns } from "./Documentslist.vue?vue&type=template&id=6ab01dac&scoped=true"
import script from "./Documentslist.vue?vue&type=script&lang=js"
export * from "./Documentslist.vue?vue&type=script&lang=js"
import style0 from "./Documentslist.vue?vue&type=style&index=0&id=6ab01dac&prod&scoped=true&lang=css"
import style1 from "./Documentslist.vue?vue&type=style&index=1&id=6ab01dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab01dac",
  null
  
)

export default component.exports